
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/card-overflow",
      function () {
        return require("private-next-pages/joy-ui/api/card-overflow.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/card-overflow"])
      });
    }
  